const identityServerUrl = process.env.VUE_APP_IDENTITY_SERVER_API_URL;

const schoolTemplate = school => ({
    id: school.id,
    name: school.name,
    domains: school.domainList || [],
    subDomain: school.subDomain,
    logo: school.logoUrl,
    primaryColor: school.primaryColor,
    secondaryColor: school.secondaryColor,

    // For error messages
    code: school.code || '',
    message: school.message || '',
});

export default {
    baseURL: identityServerUrl.concat('api/v1/identity/'),
    template: ['UNIVERSITY_TEMPLATE', schoolTemplate],
    GET: {},

    '/:id': {
        GET: {},
    },

    '/connection': {
        authorize: true,
        template: [
            'CONNECTION_TEMPLATE',
            data => {
                const school = data.school || {};

                return {
                    id: data.id,
                    studentEmail: data.studentEmail,
                    isVerified: data.isVerified,
                    schoolId: data.schoolId,
                    school: schoolTemplate(school),
                };
            },
        ],
        POST: {},
        GET: {},
        DELETE: {},

        '/:id': {
            GET: {},
            DELETE: {
                template: [
                    'DELETE_CONNECTION',
                    data => {
                        return {
                            id: 1,
                            code: data.code,
                            message: data.message,
                        };
                    },
                ],
            },
        },

        '/verify': {
            authorize: false,
            GET: {
                template: [
                    'VERIFY_CONNECTION',
                    data => {
                        return {
                            id: 1,
                            code: data.code,
                            message: data.message,
                        };
                    },
                ],
            },
        },

        '/confirm': {
            authorize: false,
            template: [
                'RESEND_EMAIL',
                data => {
                    return {
                        id: 1,
                        code: data.code,
                        message: data.message,
                    };
                },
            ],
            POST: {},
        },
    },
};
